<!-- =========================================================================================
    File Name: Email.vue
    Description: Email Application (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<!--  -->
<template>
  <!-- <div id="simple-calendar-app"> -->
  <div>
    <!-- <vx-card :title="rootModuleName"> -->
    <vx-card>


      <div slot="no-body" class="tabs-container px-6 pt-6" v-show="!showEmptyDataMessage" :key="cardKey">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner" :key="tabsKey">
          <vs-tab :label="$t('MODULES.details')">
            <vs-alert icon="warning" active="true" color="warning" class="my-5" v-show="showNoFieldsMessage">
              <span>Este módulo não possui campos.</span>
            </vs-alert>

            <div class="tab-text">
              <module-form ref="moduleForm" class="mt-4" :delegatorUrl="detail.api_delegator" :detailProp="detail" :blockDataProp="blockData"
                :permissionsProp="permissions" :enableEditProp="enableEdit" v-show="!showEmptyDataMessage"
                action-type="edit" :renderButton="false" :blockTabs="blockTabs" @onCanSaveFormChange="onOnCanSaveFormChange" />
            </div>

          </vs-tab>

          <vs-tab v-if="defaultTabs.length > 0" v-for="relatedTab in defaultTabs" :label="$displayLabel(relatedTab, 'tabName')" :key="`${relatedTab.tabIndex}`">
            <related-module-table :relatedTab="relatedTab" :rowState="fieldModel" @onCanSaveFormChange="onOnCanSaveFormChange" />
          </vs-tab>


        </vs-tabs>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!canSave">{{ $t('MODULES.submit') }}</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="danger"
              @click="$router.push($route.params.rowHash ? '/modules/' + $route.params.moduleHash : '/modules/view/' + $route.params.moduleHash)">{{ $t('MODULES.cancel') }}</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning" icon-pack="feather" icon="icon-corner-up-left"
              @click="$router.go(-1)">{{ $t('MODULES.back') }}</vs-button>
          </div>
        </div>
      </div>

      <vs-alert icon="warning" active="true" color="warning" class="my-5" v-show="showEmptyDataMessage">
        <span>Acesso negado ao módulo.</span>
      </vs-alert>

      <!-- <div style="float: right;">
            <vs-button class="ml-auto mt-2">Editar</vs-button>
          </div>   -->
    </vx-card>
  </div>
</template>

<script>

// import ModuleForm from './ModuleForm'
import ModuleForm from '../../../components/custom-modules/CustomModuleForm.vue'
import RelatedModuleTable from '../../../components/custom-modules/RelatedModuleTable.vue'
import { Edit2Icon } from 'vue-feather-icons'
import StringMask from 'string-mask'
import { performFetch } from '../../../helpers'

export default {
  components: {
    ModuleForm,
    Edit2Icon,
    RelatedModuleTable
  },
  data() {
    return {
      cardKey: 0,
      rootModuleName: '',
      relatedTabs: [],
      tableTitles: [],
      selectedRows: [],
      tabsKey: 0,
      showEmptyDataMessage: false,
      fieldData: {},
      fieldModel: {},
      defaultTabs: [],
      enableEdit: {},
      detail: {},
      blockData: [],
      permissions: {},
      activeTab: null,
      blockTabsModel: {},
      blockTabs: {},
      showNoFieldsMessage: false,
      moduleRows: [],
      canSave: true,
      optionFieldModel: [],
      firstPageLoad: true,
    }
  },
  watch: {
    async '$route.params.moduleHash'(newValue) {
      console.log('route changed')
      this.cardKey = this.cardKey + 1;
      // this.defaultTabs = JSON.parse(JSON.stringify([]));
      // this.blockData = JSON.parse(JSON.stringify([]));
      // this.detail = JSON.parse(JSON.stringify({}));
      this.firstPageLoad = true;
      this.tabsKey = this.tabsKey + 1;
      this.activeTab = 0;
      // this.$vs.loading({ type: 'default' })
      // await this.getData()
      // this.$vs.loading.close()
      // console.log('here 1')
    },
    async activeTab(newValue, oldValue) {

      if (this.activeTab === 0) {
        this.showBtnEdit = true
        this.$vs.loading({ type: 'default' })
        if (this.firstPageLoad) {
          await this.getData()
          this.firstPageLoad = false
        } else {
          await this.getData(false)
          this.tabsKey = this.tabsKey + 1
        }
        this.$vs.loading.close()
      }
      // if (this.activeTab === 0) {
      //   this.showBtnEdit = true
      //   this.$vs.loading({ type: 'default' })
      //   this.getData()
      // } else {
      //   this.showBtnEdit = false

      //   const moduleData = this.relatedTabs[this.activeTab - 1]
      //   console.log(moduleData);

      //   await performFetch(`${this.$store.state.auth.api_url}`, {
      //     command: 'list_related_module_rows',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       related_module_token: moduleData.moduleHash,
      //       module_token: this.$route.params.moduleHash,
      //       related_field_token: moduleData.fieldHash,
      //       row_hash: this.$route.params.rowHash
      //     }
      //   })
      //     .then((response) => {
      //       if (response.status === 200) {
      //         response.json().then((responseData) => {

      //           this.moduleRows = []
      //           this.tableTitles = []

      //           if (responseData.payload.length > 0) {
      //             responseData.payload.forEach((item) => {

      //               const formattedItems = []

      //               Object.entries(item.items).forEach((itemObject) => {

      //                 const objectKey = itemObject[0]
      //                 let objectValue = itemObject[1]

      //                 if (typeof objectValue === 'object' && objectValue !== null) {

      //                   if (objectValue.secret === true) {
      //                     if (this.tableTitles.find(x => x.name === objectValue.name) === undefined) {
      //                       this.tableTitles.push({
      //                         title: objectValue.title,
      //                         name: objectValue.name
      //                       })
      //                     }

      //                     objectValue = '*****'
      //                   } else {
      //                     if (this.tableTitles.find(x => x.name === objectValue.name) === undefined) {
      //                       this.tableTitles.push({
      //                         title: objectValue.title,
      //                         name: objectValue.name
      //                       })
      //                     }

      //                     if (objectValue.type_id === 16 || objectValue.type_id === 18 || objectValue.type_id === 20) {

      //                       const type_id = objectValue.type_id
      //                       const showProgressBar = objectValue.show_progress_bar

      //                       let config = null

      //                       if (objectValue.type_id === 16 || objectValue.type_id === 20) {
      //                         config = { minimumFractionDigits: objectValue.decimals, maximumFractionDigits: objectValue.decimals }
      //                       } else {
      //                         config = { style: 'currency', currency: 'BRL', minimumFractionDigits: objectValue.decimals, maximumFractionDigits: objectValue.decimals }
      //                       }

      //                       const value = parseFloat(objectValue.payload)

      //                       if (!isNaN(value)) {
      //                         objectValue = parseFloat(objectValue.payload).toLocaleString('pt-BR', config)

      //                         if (type_id === 16) {
      //                           if (showProgressBar) {
      //                             objectValue = objectValue + '%%'
      //                           } else {
      //                             objectValue = objectValue + '%'
      //                           }
      //                         }
      //                       } else {
      //                         objectValue = null
      //                       }

      //                     } else if (objectValue.mask) {
      //                       const formatter = new StringMask(objectValue.mask)
      //                       const result = formatter.apply(objectValue.payload)

      //                       objectValue = result
      //                     } else {
      //                       objectValue = objectValue.payload
      //                     }

      //                     const isDateTime = this.checkIfStringIsDateTime(objectValue)

      //                     if (isDateTime) {

      //                       const date = objectValue.split(' ')[0].trim()
      //                       const time = objectValue.split(' ')[1].trim()

      //                       objectValue = `${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]} ${time}`

      //                     }


      //                     const isDate = this.checkIfStringIsDate(objectValue)

      //                     if (isDate) {

      //                       objectValue = `${objectValue.split('-')[2]}/${objectValue.split('-')[1]}/${objectValue.split('-')[0]}`
      //                     }
      //                   }

      //                   itemObject[1] = objectValue
      //                 }

      //                 const fieldObject = {
      //                   key: itemObject[0],
      //                   value: itemObject[1]
      //                 }

      //                 formattedItems.push(fieldObject)
      //               })

      //               formattedItems.push({ key: '__hash', value: item.identification })

      //               const moduleRow = {}

      //               formattedItems.forEach((item) => {
      //                 moduleRow[item['key']] = item['value']
      //               })

      //               this.moduleRows.push(moduleRow)
      //             })
      //           }

      //           console.log(this.tableTitles)

      //           this.$vs.loading.close()
      //         })
      //           .catch(e => {
      //             console.log(e)
      //             this.$vs.loading.close()
      //             this.$vs.notify({
      //               title: 'Atenção!',
      //               text: e.message,
      //               iconPack: 'feather',
      //               icon: 'icon-alert-circle',
      //               color: 'danger'
      //             })
      //             throw new Error(e.message)
      //           })
      //       } else if (response.status === 400) {
      //         this.$vs.loading.close()
      //         this.moduleRows = []
      //       } else if (response.status === 403) {
      //         this.$vs.loading.close()
      //         this.showEmptyDataMessage = true
      //       } else if (response.status === 401) {
      //         setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
      //         this.$store.dispatch('auth/signOut')
      //       } else {
      //         this.$vs.loading.close()
      //         this.$vs.notify({
      //           title: 'Operação não realizada!',
      //           text: 'Ocorreu um erro ao listar os registros do módulo',
      //           iconPack: 'feather',
      //           icon: 'icon-alert-circle',
      //           color: 'danger'
      //         })
      //       }
      //     })
      //     .catch((e) => {
      //       console.log(e)
      //       this.$vs.loading.close()
      //       this.$vs.notify({
      //         title: 'Atenção!',
      //         text: e.message,
      //         iconPack: 'feather',
      //         icon: 'icon-alert-circle',
      //         color: 'danger'
      //       })
      //       throw new Error(e.message)
      //     })
      // }
      // }
    }
  },
  computed: {

  },
  async created() {

  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('auth/SET_CURRENT_MODULE_NAME', null)
    next()
  },
  async mounted() {
    this.$vs.loading({ type: 'default' })
    await this.getData()
    this.$vs.loading.close()
  },
  methods: {
    buildBlocks() {
      for (let block of this.blockData) {
        block.fields.sort((a, b) => a.index - b.index)
        for (let fieldItem of block.fields) {
          this.setFieldsModels(fieldItem)
        }
      }
    },
    setFieldsModels(fieldItem) {

      if (fieldItem.payload === '') {
        fieldItem.payload = null
      }

      if (fieldItem.type_id === 20) {

        if (fieldItem.payload === '' || fieldItem.payload === null) {
          fieldItem.payload = 0
        } else {
          fieldItem.payload = parseFloat(fieldItem.payload)
        }
      } else if (fieldItem.type_id === 16) {

        if (fieldItem.payload === '' || fieldItem.payload === null) {
          fieldItem.payload = 0
        } else {
          fieldItem.payload = parseFloat(fieldItem.payload)
        }
      } else if (fieldItem.type_id === 18) {

        if (fieldItem.payload === '' || fieldItem.payload === null) {
          fieldItem.payload = 0
        } else {
          fieldItem.payload = parseFloat(fieldItem.payload)
        }
      } else if (fieldItem.type_id === 24) {

        this.$set(this.fieldModel, fieldItem.hash, {})
        const optionsList = []
        fieldItem.options.forEach((optionFieldItem) => {

          optionsList.push({ hash: optionFieldItem.value, name: optionFieldItem.label })

          if (optionFieldItem.selected) {
            this.fieldModel[fieldItem.hash] = { hash: optionFieldItem.value, name: optionFieldItem.label }
          }
        })

        this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
      } else if (fieldItem.type_id === 29) {
        this.$set(this.fieldModel, fieldItem.hash, {})
        const optionsList = []
        fieldItem.options.forEach((optionFieldItem) => {
          optionsList.push({ hash: optionFieldItem.value, label: optionFieldItem.label, color: optionFieldItem.color })
        })

        const defaultValue = optionsList.find(x => x.label === fieldItem.default_value)

        this.$set(this.fieldModel, fieldItem.hash, defaultValue)

        // this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
      } else if (fieldItem.type_id === 25 || fieldItem.type_id === 30) {
        this.$set(this.fieldModel, fieldItem.hash, {})
        const optionsList = []
        if (Array.isArray(fieldItem.options)) {
          fieldItem.options.forEach((optionFieldItem) => {

            optionsList.push({ hash: optionFieldItem.value, name: optionFieldItem.label })

            if (optionFieldItem.selected) {
              this.fieldModel[fieldItem.hash] = { hash: optionFieldItem.value, name: optionFieldItem.label }
            }
          })
        } else {
          // this.$set(this.dependentFieldOptions, fieldItem.hash, fieldItem.options)

          if (JSON.stringify(this.fieldModel[fieldItem['related_parent_hash']]) === '{}') {
            // this.$set(this.optionFieldModel, fieldItem.hash, [])
            // this.$set(this.dependentFieldDisableStatus, fieldItem.hash, true)
          } else {

            Object.keys(fieldItem.options).forEach(item => {
              fieldItem.options[item].forEach((itemOption) => {
                if (item === this.fieldModel[fieldItem['related_parent_hash']].hash) {
                  if (itemOption.selected) {
                    this.fieldModel[fieldItem.hash] = { hash: itemOption.value, name: itemOption.label }
                  }
                }
              })
            })

            // this.relatedModuleFieldChange(fieldItem['related_parent_hash'], this.fieldModel[fieldItem['related_parent_hash']], defaultOption)
          }
        }

        this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
      } else if (fieldItem.type_id === 21) {
        this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
      } else if (fieldItem.type_id === 22) {
        this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
      } else if (fieldItem.type_id === 27) {

        this.fillMapFields()
        if (typeof fieldItem.payload === 'string' && fieldItem.payload.split(',').length > 0) {
          fieldItem.payload = { lat: parseFloat(fieldItem.payload.split(',')[0]), lng: parseFloat(fieldItem.payload.split(',')[1]) }
        } else {
          fieldItem.payload = { lat: -23.501103, lng: -46.8504457 }
        }

      } else if (fieldItem.type_id === 28) {
        this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
      }

      if (fieldItem.type_id !== 24 && fieldItem.type_id !== 25 && fieldItem.type_id !== 29 && fieldItem.type_id !== 30) {
        this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
      }

    },
    saveChanges() {
      this.$refs.moduleForm.saveChanges();
    },
    onOnCanSaveFormChange(val) {
      this.canSave = val;
    },
    goRelatedModule(moduleHash, recordHash) {
      this.$router.push(`/modules/view/${moduleHash}/${recordHash}`)
    },
    checkIfStringIsDateTime(string) {

      try {
        if ((string.split('-').length - 1) == 2 && (string.split(':').length - 1) == 2 && (string.split(' ').length - 1) == 1) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    checkIfStringIsDate(string) {
      try {
        if ((string.split('-').length - 1) == 2 && (string.length === 10)) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    handleSearch() {

    },
    handleChangePage() {

    },
    handleSort() {

    },
    async getData(loadTabs = true) {

      const requestBody = {
        application_token: this.$store.state.auth.app_token,
        module_token: this.$route.params.moduleHash,
        session_token: this.$store.state.auth.token
      }

      this.defaultTabs = JSON.parse(JSON.stringify([]));
      this.blockTabs = JSON.parse(JSON.stringify({}));

      if (this.$route.params.rowHash) {
        requestBody['row_hash'] = this.$route.params.rowHash
      }

      return await performFetch(this.$store.state.auth.api_url, {
        command: 'get_module_row',
        parameters: requestBody
      })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {
            return response.json().then(async (responseData) => {

              this.rootModuleName = responseData.detail.module_name

              if (responseData.related_tabs.length > 0) {

                let tabIndex = 1

                responseData.related_tabs.forEach((item) => {

                  let icon = item.icon.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`)

                  icon = icon.replace('-icon', '')

                  icon = 'icon' + icon

                  // const found = this.defaultTabs.find(element => element.moduleHash === item.module_hash)

                  this.defaultTabs.push({
                    tabIndex: tabIndex,
                    index: item.index,
                    name: item.module_name,
                    icon: icon,
                    tabName: item.tab_name === null ? item.module_name : item.tab_name,
                    tabName_en: item.tab_name_en || null,
                    recordHash: item.record_hash,
                    moduleHash: item.module_hash,
                    fieldHash: item.field_hash,
                    callApi: item.call_api
                  })

                  tabIndex++
                })

                // this.defaultTabs = JSON.parse(JSON.stringify([]));
                // this.defaultTabs = JSON.parse(JSON.stringify(tempTabs))

              }

              if (loadTabs && Object.keys(responseData.custom_module_tabs).length > 0) {

                Object.entries(responseData.custom_module_tabs).forEach((objectData, index) => {
                  const [blockHash, blockTabs] = objectData

                  this.$set(this.blockTabsModel, blockHash, 0)

                  if (!this.blockTabs.hasOwnProperty(blockHash)) {
                    this.blockTabs[blockHash] = []
                  }

                  blockTabs.forEach((value, key) => {
                    let icon = 'icon' + value.icon.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`).replace('-icon', '')

                    this.blockTabs[blockHash].push({
                      tabIndex: key,
                      index: value.index,
                      name: value.module_name,
                      icon: icon,
                      tabName: value.tab_name === null ? value.module_name : value.tab_name,
                      tabName_en: value.tab_name_en || null,
                      recordHash: value.record_hash,
                      moduleHash: value.module_hash,
                      fieldHash: value.field_hash,
                      callApi: value.call_api
                    })
                  })
                  // item.forEach(value => {
                  //   console.log(value)
                  // })
                })

              }

              this.detail = responseData.detail
              this.apiDelegator = responseData.detail.api_delegator
              this.apiToken = responseData.api_token
              this.detail.module_hash = this.$route.params.moduleHash
              this.showBtnPrint = responseData.detail.show_print_button
              this.btnPrintTimeout = responseData.detail.max_print_timeout
              this.btnPrintLabel = responseData.detail.print_button_label
              document.title = `${document.title.split(' | ')[0]} | ${this.$displayLabel(responseData.detail, 'module_name')}`
              this.$store.commit('auth/SET_CURRENT_MODULE_NAME', { module_name: responseData.detail.module_name, module_name_en: responseData.detail.module_name_en })
              // if (responseData.payload.length > 0) {
              //   //   if (responseData.hasOwnProperty('data')) {
              //   //     this.rowData = responseData.data.reduce((obj, item) => (obj[item.hash] = item.payload, obj), {})
              //   //   }
              //   //   const visibleBlocks = responseData.payload.filter((el) => el.visible)
              //   //   if (visibleBlocks.length === 0) {
              //   //     this.showNoFieldsMessage = true
              //   //   }
              //   //   this.permissions = responseData.permissions
              //   // } else {
              //   //   this.showEmptyDataMessage = !this.showEmptyDataMessage
              // }

              if (responseData.payload.length > 0) {
                this.detail.module_hash = this.$route.params.moduleHash
                this.blockData = responseData.payload
                this.buildBlocks()
                this.permissions = responseData.permissions
                // if(this.firstPageLoad) {
                // }
                this.activeTab = 0
              } else {
                this.showEmptyDataMessage = !this.showEmptyDataMessage
              }

              // if (responseData.detail.identifier_field !== null) {
              //   let moduleFieldValue = null

              //   for (const block of responseData.payload) {
              //     for (const field of block.fields) {
              //       if (field.hash === responseData.detail.identifier_field) {
              //         moduleFieldValue = field.payload
              //       }
              //     }
              //   }

              //   // this.$store.dispatch('relatedModuleNavigation/addNavigationHistory', {
              //   //   'name': responseData.detail.module_name,
              //   //   'value': moduleFieldValue
              //   // })


              // }

              // const moduleData = this.defaultTabs[this.modulesActiveTab]

              // if (this.perPage === null) {
              //   await this.getModuleParameters(moduleData.moduleHash)
              // }

              // await this.listModuleRows(moduleData)

              // this.modulesActiveTab = 0
            })


            // response.json().then(async (responseData) => {

            //   if (responseData.related_tabs.length > 0) {

            //     let tabIndex = 1

            //     responseData.related_tabs.forEach((item) => {

            //       const found = this.relatedTabs.find(element => element.moduleHash === item.module_hash)

            //       if (found === undefined || !found) {
            //         this.relatedTabs.push({
            //           tabIndex: tabIndex,
            //           index: item.index,
            //           name: item.module_name,
            //           tabName: item.tab_name === null ? item.module_name : item.tab_name,
            //           recordHash: item.record_hash,
            //           moduleHash: item.module_hash,
            //           fieldHash: item.field_hash
            //         })
            //       }

            //       tabIndex++
            //     })
            //   }

            //   this.detail = responseData.detail
            //   document.title = `${document.title.split(' | ')[0]} | ${responseData.detail.module_name}`
            // this.$store.commit('auth/SET_CURRENT_MODULE_NAME', responseData.detail.module_name)
            //   if (responseData.payload.length > 0) {
            //     this.detail.module_hash = this.$route.params.moduleHash
            //     this.blockData = responseData.payload
            //     this.permissions = responseData.permissions
            //     this.activeTab = 0
            //   } else {
            //     this.showEmptyDataMessage = !this.showEmptyDataMessage
            //   }
            // })



          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.showEmptyDataMessage = !this.showEmptyDataMessage
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.showEmptyDataMessage = !this.showEmptyDataMessage
          throw new Error(e.message)
        })
    }
  }
}

</script>


<style lang="scss">
.text-muted {
  font-size: 11px;
  color: #839bb3 !important;
  padding-left: 5px;
}

.vs-input--label {
  font-size: 14px;
}
</style>
